import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'

export const Section = styled.div`
  margin: 72px 0px;
  padding: 40px 0px;
  position: relative;
  background-color: ${(props) => props.theme.lavender};
  @media (max-width: ${breakpoints.s}px) {
    padding: 40px 0px;
    margin: 42px 0px;
  }
`
export const Header = styled.p`
  font-size: 12px;
  line-height: 18px;
  margin: 0px 0px 40px;
  text-align: left;
  font-family: 'MatterBold';
  letter-spacing: 1px;
  @media (max-width: ${breakpoints.m}px) {
    margin: 0px;
    font-size: 12px;
    line-height: 18px;
  }
`
export const Container = styled.div`
  width: 90%;
  margin: auto;
  max-width: 1060px;
`
